import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBloglovinComponent } from './simple-icons-bloglovin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBloglovinComponent ],
    exports:      [ SimpleIconsBloglovinComponent ],
    bootstrap:    []
})
export class SimpleIconsBloglovinModule {}
